import { NavLink, Outlet, useNavigate } from 'react-router-dom'
import { attendeeAuth } from '@/api/attendee'
import { CalendarDays, Award, User, LogOut } from 'lucide-react'

const navClass = ({ isActive }: { isActive: boolean }) =>
  `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
    isActive ? 'bg-indigo-50 text-indigo-700' : 'text-slate-500 hover:text-slate-800 hover:bg-slate-50'
  }`

export default function AttendeeLayout() {
  const navigate = useNavigate()
  const name = attendeeAuth.name()

  const logout = () => {
    const slug = attendeeAuth.slug()
    attendeeAuth.clear()
    navigate(slug ? `/attendee/${slug}/login` : '/', { replace: true })
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <span className="font-semibold text-slate-800">My training</span>
          <div className="flex items-center gap-3">
            {name && <span className="text-sm text-slate-500 hidden sm:inline">{name}</span>}
            <button onClick={logout} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800">
              <LogOut size={15} /> Sign out
            </button>
          </div>
        </div>
        <nav className="max-w-3xl mx-auto px-4 pb-2 flex gap-1">
          <NavLink to="/attendee/overview" className={navClass}><CalendarDays size={15} /> Bookings</NavLink>
          <NavLink to="/attendee/certificates" className={navClass}><Award size={15} /> Certificates</NavLink>
          <NavLink to="/attendee/profile" className={navClass}><User size={15} /> Profile</NavLink>
        </nav>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
